export default __webpack_public_path__ + "static/media/info-search.0103d4e5.jpg";